document.addEventListener('DOMContentLoaded', () => {
  const updateTableWithSortedItems = (tableId, itemsClass) => {
    const table = document.querySelector(tableId);
    // tableが存在しない場合、関数を終了
    if (!table) return;

    const items = Array.from(document.querySelectorAll(itemsClass));
    // itemsが存在しない、またはitemsが空の場合、関数を終了
    if (!items || items.length === 0) return;

    let templateString = '';

    items
      .sort((a, b) => {
        const aValue = a.dataset.order ? Number(a.dataset.order) : 999999;
        const bValue = b.dataset.order ? Number(b.dataset.order) : 999999;
        return aValue - bValue;
      })
      .forEach(item => (templateString += item.outerHTML));

    table.innerHTML = templateString;
  };

  updateTableWithSortedItems('#productSizeTable', '.productDetail__info__size__table__size');
  updateTableWithSortedItems('#productSizeTableSp', '.productDetail__info__size__table__sizeSp');
  updateTableWithSortedItems(
    '.productDetail__info__category__name__size',
    '.productDetail__info__category__name__size__productSize'
  );
  updateTableWithSortedItems(
    '.productDetail__info__category__name__sizeSp',
    '.productDetail__info__category__name__size__productSizeSp'
  );
});
